// extracted by mini-css-extract-plugin
export default {"body1":"body-01_body1__3vl74","semibold":"body-01_semibold__E9umf","link":"body-01_link__BpFFV","error":"body-01_error__CO-ZK"};